// extracted by mini-css-extract-plugin
export var locationCard = "_hz-0";